// Registration JS

$(document).ready(function(){
    // alert('reg');
    // type1: חבר האיגוד
    // type2: מתמחה חבר האיגוד
    // type3:  חבר פורום מומחים

    // type4: חבר הר״ש
    // type5: שאינו חבר הר״ש
    // type6: שיננית

    // ===================================================
    // ==========  Initial ===============================
    // ===================================================

    // declare package type
    var packageType = '';
    var totalSum = 0;


    // ===================================================
    // ==== Handle Package Selection =====================
    // ===================================================

    // choosing the package
    $('.package-wrap a').click(function(){
        $('.package-wrap a').not(this).each(function(){
            $(this).addClass('disabled');
            $(this).parent().addClass('childDisabled');
            $('.packages-wrap').click(false);
            $('.package-wrap a').unbind("click");
        });
        // disable the packages, update the price.
        $(this).unbind("click");

        // get the price from package and set it to packageCost.
        $('#packageCost').text(($(this).find(".price").text()));

        // save the package type chosen.
        packageType = $(this).attr('id');
        $('#packageType').val(packageType);

        // show the form
        $('.payment-form').removeClass("hidden");
        updateCost();
    });




    // ============================================================
    // ==== Prefix - Handle the Prefix of the Name (Dr, Prof) =====
    // ============================================================

    // getting the prefix of the user from select and sending it in prefix hidden field.
    var prefixSelect =  $('select[name="prefix"]');
    var prefix = $('input[name="prefix"]');
    // load initial value to prefix
    prefix.val($(this).find("option:selected").text());

    prefixSelect.change(function () {
        prefix.val($(this).find("option:selected").text());
    });

    // ===================================================
    // ==== Full Name - handle change of gala. ===========
    // ===================================================

    // get the fullName to the contact field.
    var firstName = $('#firstNameInput');
    var lastName = $('#lastNameInput');

    // get the fullName to the contact field.
    firstName.keyup (function () {
        $('#contactInput').val( firstName.val() + " " + lastName.val() );
    });
    lastName.keyup (function () {
        $('#contactInput').val( firstName.val() + " " + lastName.val() );
    });



    // ===================================================
    // ==== Before Submit ================================
    // ===================================================

    $('#registrationForm').submit(function() {

        var formData = $("#registrationForm").serialize();
        formData = formData + '&action=log';
        formData = formData + '&activity=WentToPayment';
        $.ajax({ url: '/logger',
            data: formData ,
            async: false,
            type: 'post',
            success: function(output) {

            }
        });

        return true; // return false to cancel form action
    });



    // ===================================================
    // ==== Helper Functions =============================
    // ===================================================

    // Function that will add "anotherAmount" to the cost and update display and sent field.
    function updateCost() {
        // make sure to cast to int.
        var packageCost = parseInt($('#packageCost').text());
        totalSum = packageCost;
        // update the real sum field
        $('#totalSum').val(totalSum);
        // update the display sum field.
        $('#displayPrice').text(totalSum.toLocaleString('en'));

    }


    
});
